import { useEffect } from "react";
import Homelab from "./components/Homelab";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Contact from "./components/Contact";

function App() {
  useEffect(() => {
    let active = true;
    const scrollToHash = () => {
      if (active && window.location.hash) {
        document.getElementById(window.location.hash.slice(1))?.scrollIntoView({ behavior: "instant", block: "start" });
      }
    };
    const frame = requestAnimationFrame(scrollToHash);
    document.fonts.ready.then(scrollToHash);
    window.addEventListener("load", scrollToHash, { once: true });
    return () => {
      active = false;
      cancelAnimationFrame(frame);
      window.removeEventListener("load", scrollToHash);
    };
  }, []);

  return (
    <div className="bg-dark min-h-screen relative">
      <div
        className="fixed inset-0 pointer-events-none z-[9999] opacity-[0.03]"
        aria-hidden="true"
      >
        <svg className="w-full h-full">
          <filter id="grain">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0.65"
              numOctaves="3"
              stitchTiles="stitch"
            />
          </filter>
          <rect width="100%" height="100%" filter="url(#grain)" />
        </svg>
      </div>
      <Navbar />
      <Hero />
      <Skills />
      <Projects />
      <Homelab />
      <Contact />
    </div>
  );
}

export default App;
